<div class="cpcontent">
    <h2>Testing Richt Text Editor Component</h2>
    <button class="btn btn-primary" (click)="showEditor = true">Show Editor</button>
    <div style="max-width:1200px" *ngIf="showEditor">
        <app-richtext [content]="content" (contentChange)="contentChanged($event)"></app-richtext>
    </div>
    <hr>
    Test content: <br>
    <span *ngIf="showEditor == false" [innerHTML]="content"></span>
</div>